export const split_email_to_fit_in_small_boxes_layout = (email_original: string) => {

    let email_array = email_original.split('@')
    let to_return = email_array[0] + '@\n' + email_array[1]
    return to_return
}
